import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { api, setToken, setUser } from '../../utils/api';
import { loginRequest } from '../../authConfig';
import { AuthLayout } from '../../components/Layout';
import { Btn, Alert } from '../../components/UI';

export const REDIRECT_TOKEN_KEY = 'basecamp_ms_redirect_idtoken';

export default function LoginPage() {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // 2) Razmena ID tokena za basecamp JWT (backend verifikuje + JIT-provision).
  async function finishLogin(idToken) {
      if (!idToken) throw new Error('Microsoft did not return a token.');
      const data = await api.loginMicrosoft(idToken);
      setToken(data.token);
      setUser(data.user);
      const roles = data.user?.roles || [];
      const landing = roles.includes('IP') ? '/home'
        : roles.includes('CAND') ? '/journey'
        : roles.includes('SUPERADMIN') ? '/admin/users'
        : roles.includes('ADM') ? '/operations'
        : roles.includes('SH') ? '/governance'
        : roles.includes('BP') ? '/exchange'
        : '/hbworld';
      navigate(landing);
  }

  // Povratak sa redirect prijave: index.js je preuzeo ID token (handleRedirectPromise).
  useEffect(() => {
    const pending = sessionStorage.getItem(REDIRECT_TOKEN_KEY);
    if (!pending) return;
    sessionStorage.removeItem(REDIRECT_TOKEN_KEY);
    setLoading(true);
    finishLogin(pending).catch(err => setError(err.message || 'Sign-in failed.')).finally(() => setLoading(false));
  }, []);

  async function handleMicrosoftLogin() {
    setError(null);
    setLoading(true);
    try {
      // 1) MS prijava kroz popup -> dobijamo ID token.
      const result = await instance.loginPopup(loginRequest);
      await finishLogin(result.idToken);
    } catch (err) {
      // Korisnik je zatvorio popup -> ne prikazuj gresku.
      if (err?.errorCode === 'user_cancelled') { setLoading(false); return; }
      // Popup blokiran (browser podešavanja, ugrađeni browser-i) -> prijava preusmeravanjem
      // u istom prozoru; posle povratka na /login prijava se završava gore (useEffect).
      if (['popup_window_error', 'empty_window_error', 'monitor_window_timeout'].includes(err?.errorCode)) {
        await instance.loginRedirect({ ...loginRequest, redirectStartPage: `${window.location.origin}/login` });
        return;
      }
      setError(err.message || 'Sign-in failed.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <p style={{ fontSize: '0.86rem', fontStyle: 'italic', color: 'var(--ink-soft)', margin: 0, textAlign: 'center', lineHeight: 1.5 }}>
          An Ice Pilot is a jazz musician — knowing every note is not the point. Playing the room is.
        </p>

        {error && <Alert type="error">{error}</Alert>}

        <p style={{ fontSize: '0.9rem', color: 'var(--ink-faint)', margin: 0, textAlign: 'center' }}>
          Sign in with your Hansen Beck (@hansenbeck.com) account.
        </p>

        <Btn
          onClick={handleMicrosoftLogin}
          loading={loading}
          style={{ justifyContent: 'center', gap: '10px' }}
        >
          {!loading && <MicrosoftLogo />}
          Sign in with Microsoft
        </Btn>
      </div>
    </AuthLayout>
  );
}

function MicrosoftLogo() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" style={{ flexShrink: 0 }}>
      <rect x="0" y="0" width="7" height="7" fill="#F25022" />
      <rect x="9" y="0" width="7" height="7" fill="#7FBA00" />
      <rect x="0" y="9" width="7" height="7" fill="#00A4EF" />
      <rect x="9" y="9" width="7" height="7" fill="#FFB900" />
    </svg>
  );
}
